import React, { useState } from "react";
import PropTypes from "prop-types";
import { Spin, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import OwnerLoader from "./OwnerLoader";
import IdentitySearchSelect from "../common/IdentitySearchSelect";

const OwnerEdit = ({ group, loading, onSelect, disabled }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedIdentity, setSelectedIdentity] = useState(null);

  const handleIdentitySelect = (identity) => {
    setSelectedIdentity(identity);
    onSelect?.(identity);
    setIsEditing(false);
  };

  const clearIdentityFilter = () => {
    setSelectedIdentity(null);
    setIsEditing(false);
    onSelect?.(null);
  };

  return (
    <Spin spinning={loading}>
      {group ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <OwnerLoader ownerId={group.ownerId} />

          {!disabled && (
            <>
              {isEditing ? (
                <IdentitySearchSelect
                  autoFocus
                  placeholder="Transfer to new owner"
                  value={selectedIdentity}
                  onSelect={handleIdentitySelect}
                  onClear={clearIdentityFilter}
                  style={{ width: 240 }}
                  searchFilter={["source:cern"]}
                />
              ) : (
                <Button
                  size="small"
                  onClick={() => setIsEditing(true)}
                  icon={<EditOutlined />}
                  color="green"
                  variant="solid"
                />
              )}
            </>
          )}
        </div>
      ) : (
        <span>None</span>
      )}
    </Spin>
  );
};

OwnerEdit.propTypes = {
  group: PropTypes.object,
  onSelect: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default OwnerEdit;
